<template>
  <div class="contact">
    <TemplatePageGrid
      :items="workClientContactGridEmail"
      :page-data="pageDataEmail"
      :page_params="params.email"
      :loading="loadingAnimationEmail"
    >
      <template v-slot:buttons>
        <WorkClientContactModal
          v-if="$userCheckAccess({abilities: 'edit_client_contacts'})"
          create
          type="email"
        />
      </template>
      <WorkClientContactTable :items="workClientContactGridEmail" type="email"/>
    </TemplatePageGrid>
    <TemplatePageGrid
      :items="workClientContactGridPhone"
      :page-data="pageDataPhone"
      :page_params="params.phone"
      :loading="loadingAnimationPhone"
      class="mt-5"
    >
      <template v-slot:buttons>
        <WorkClientContactModal
          v-if="$userCheckAccess({abilities: 'edit_client_contacts'})"
          create
        />
      </template>
      <WorkClientContactTable :items="workClientContactGridPhone"/>
    </TemplatePageGrid>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

import WorkClientContactTable from 'components/workClient/contact/WorkClientContactTable'
import WorkClientContactModal from 'components/workClient/contact/WorkClientContactModal'

export default {
  name: 'WorkClientContact',
  components: {
    WorkClientContactTable,
    WorkClientContactModal,
  },
  data() {
    return {
      params: {
        email: {
          page: 'email_page',
          limit: 'email_limit',
        },
        phone: {
          page: 'phone_page',
          limit: 'phone_limit',
        },
      },
    }
  },
  created() {
    this.onWorkClientContactGridEmail({
      limit: this.$route.query[this.params.email.limit],
      page: this.$route.query[this.params.email.page],
      id: this.$route.params.id,
    }),
      this.onWorkClientContactGridPhone({
        limit: this.$route.query[this.params.phone.limit],
        page: this.$route.query[this.params.phone.page],
        id: this.$route.params.id,
      })
  },
  computed: {
    ...mapGetters('workClientContact', [
      'workClientContactGridEmail',
      'workClientContactGridPhone',
      'loadingAnimationEmail',
      'loadingAnimationPhone',
      'pageDataEmail',
      'pageDataPhone',
    ]),
  },
  methods: {
    ...mapActions('workClientContact', [
      'onWorkClientContactGridEmail',
      'onWorkClientContactGridPhone',
    ]),
  },
  watch: {
    '$route.query.email_page'() {
      this.onWorkClientContactGridEmail({
        limit: this.$route.query[this.params.email.limit],
        page: this.$route.query[this.params.email.page],
        id: this.$route.params.id,
      })
    },
    '$route.query.email_limit'() {
      this.onWorkClientContactGridEmail({
        limit: this.$route.query[this.params.email.limit],
        page: this.$route.query[this.params.email.page],
        id: this.$route.params.id,
      })
    },
    '$route.query.phone_page'() {
      this.onWorkClientContactGridPhone({
        limit: this.$route.query[this.params.phone.limit],
        page: this.$route.query[this.params.phone.page],
        id: this.$route.params.id,
      })
    },
    '$route.query.phone_limit'() {
      this.onWorkClientContactGridPhone({
        limit: this.$route.query[this.params.phone.limit],
        page: this.$route.query[this.params.phone.page],
        id: this.$route.params.id,
      })
    },
  },
}
</script>
